import { DialogContent, DialogTitle, Stack, Typography } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { If } from "lib/@components/switch"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { AuthoringBoundTextEditor } from "authoring/components/authoring-editor"

// Only one of these dialogs is open at a time, so fixed ids are safe for aria-labelledby.
export const SECTION_DIALOG_TITLE_ID = "schedule-commentary-section-dialog-title"
const CONTENT_LABEL_ID = "schedule-commentary-section-dialog-content-label"

// Used to add a section, edit any section, and edit the overview (which has no description).
export function ScheduleCommentarySectionDialog({ heading, okCaption, section, showDescription = true }) {
    return (
        <DataInputDialog
            initialValue={{
                title: section?.title ?? "",
                description: section?.description ?? "",
                content: section?.content ?? "",
            }}
            okCaption={okCaption}
            startValid={Boolean(section?.title)}
        >
            <DialogTitle id={SECTION_DIALOG_TITLE_ID}>{heading}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ pt: 1.5 }} data-cy="schedule-commentary-section-dialog">
                    <BoundTextField field="title" label="Title" size="small" autoFocus yup="string.trim.required" />
                    <If truthy={showDescription}>
                        <BoundTextField
                            field="description"
                            label="Description"
                            size="small"
                            multiline
                            minRows={2}
                            data-cy="schedule-commentary-section-dialog-description-field"
                        />
                    </If>
                    <Stack
                        spacing={1}
                        role="group"
                        aria-labelledby={CONTENT_LABEL_ID}
                        data-cy="schedule-commentary-section-dialog-content-field"
                    >
                        <Typography variant="subtitle2" id={CONTENT_LABEL_ID}>
                            Content
                        </Typography>
                        <AuthoringBoundTextEditor field="content" label="" workplaceMaxHeight={260} />
                    </Stack>
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
